$(() => {
    $("#close-announcement-bar").click(() => {
        // Hide for 1 day
        const date = new Date()
        date.setDate(date.getDate() + 1);

        document.cookie = "hide_announcement_bar=true;expires="+date.toUTCString()+";path=/;";
        $(".announcement_component").addClass("hidden")

        // Auto refresh page
        setTimeout(() => {
            window.location.reload()
        }, 1000);
    });
});


// WEBPACK FOOTER //
// ./app/components/dashboard/announcement_component/announcement_component.js